// Page: Contact
if ($('body').hasClass('page--contact')) {
  $(".locations__cities li").hover(function(){
      var $city = $(this).attr("data-city");   
      $('.locations__icons li[data-icon='+$city+'] svg').addClass("highlight-icon");
      }, function(){
      $('.locations__icons li svg').removeClass("highlight-icon");
  });
}
